import { slugify } from './productUrl';
import { matchesCollection } from './collectionMatching';

const categorySlugs = {
  airpods: 'airpods', ecouteurs: 'airpods', audio: 'airpods',
  chargeur: 'chargeurs', chargeurs: 'chargeurs',
  smartwatch: 'montres-connectees', 'smart-watch': 'montres-connectees', 'smart-watches': 'montres-connectees',
  montres: 'montres-connectees', 'montres-connectees': 'montres-connectees',
  powerbank: 'powerbanks', powerbanks: 'powerbanks', 'power-bank': 'powerbanks',
  gps: 'gps', iphone: 'iphones', iphones: 'iphones', smartphones: 'iphones',
};

export const getCategoryLandingPath = (category) => {
  const collection = categorySlugs[slugify(category?.name)];
  return collection ? `/collections/${collection}-fes` : null;
};

export const getCategoryNavigationPath = (category) =>
  `/shop?category=${encodeURIComponent(category.id)}`;

// Browse real stock in the existing shop, using IDs supplied by the catalogue.
export const getCollectionShopPath = (collection, catalog) => {
  const products = catalog.filter(product => matchesCollection(product, collection));
  if (!products.length) return null;
  if (collection.kind === 'brand') {
    const brand = products.map(product => product.subcategory)
      .find(subcategory => matchesCollection({ subcategory }, collection)) || collection.search;
    return `/shop?search=${encodeURIComponent(brand)}`;
  }
  const categoryId = products.find(product => product.category_id != null)?.category_id;
  return categoryId != null ? getCategoryNavigationPath({ id: categoryId }) : '/shop';
};

export const getBrandLandingPath = (subcategory) => {
  const name = slugify(subcategory?.name);
  const brand = name === 'kieselect' ? 'kieslect' : ['sound-peats', 'sound-peat'].includes(name) ? 'soundpeats' : name;
  return ['ugreen', 'oraimo', 'kieslect', 'soundpeats', 'moi'].includes(brand)
    ? `/collections/${brand}-fes` : null;
};
